/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/structural_template/canvas_template/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasTemplatePreview } from "./constants";
import type { EngagementCanvasTemplatePreviewResult } from "./types";

export const getCanvasTemplatePreview = reactQueryFetcherAdapter(
  engagementCanvasTemplatePreview,
  (signal: AbortSignal, appGroupId: string, id: string): Promise<EngagementCanvasTemplatePreviewResult> => {
    return fetch(`/engagement/${appGroupId}/structural_template/canvas_template/${id}`, "GET", {}, { signal });
  }
);
